'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var emerald7 = exports.emerald7 = '#32895C';
var emerald6 = exports.emerald6 = '#409B69';
var emerald5 = exports.emerald5 = '#4CAC75';
var emerald4 = exports.emerald4 = '#5ABE82';
var emerald3 = exports.emerald3 = '#77C987';
var emerald2 = exports.emerald2 = '#94D38C';
var emerald1 = exports.emerald1 = '#B0DE91';
var emerald = {
  7: emerald7,
  6: emerald6,
  5: emerald5,
  4: emerald4,
  3: emerald3,
  2: emerald2,
  1: emerald1
};
exports.default = emerald;